import { AlgoMode, Brand, SbCreativeType, SBStrategy } from "@front/m19-api-client";
import { BrandNameMaxLength } from "@front/m19-models/SbLimits";
import { LandingPage } from "@front/m19-services";
import type { AlgoModeConfig } from "@m19-board/shared/algo-mode-selection/algo-mode-selection.component";
import type { SbFormAssetsModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-form-assets/sb-form-assets.component";

export const setupDefaultFormModel = {
  name: "",
  brand: null,
  algo: {
    algoMode: AlgoMode.ACOS_TARGET,
    acosTarget: undefined,
    isValid: false,
  },
};

export function algoConfigFromStrategy(strategy: SBStrategy): Partial<AlgoModeConfig> {
  return {
    algoMode: strategy.algoMode,
    acosTarget: strategy.acosTarget != null ? Math.round(strategy.acosTarget * 100) : undefined,
    monthlyBudget: strategy.monthlyBudget,
    suggestedBid: strategy.suggestedBid,
    dailyBudget: strategy.dailyBudget,
    isValid: true,
  };
}

export function algoConfigForTacosTarget(): Partial<AlgoModeConfig> {
  return {
    algoMode: AlgoMode.TACOS_TARGET,
    isValid: true,
  };
}

export const formatDefaultFormModel = {
  sbCreativeType: SbCreativeType.manualCollection,
  sbLandingPage: LandingPage.ProductListing,
  store: null,
};

export const assetsDefaultFormModel = {
  brandName: "",
  headline: "",
  brandLogo: null,
  video: null,
};

export const creativesSbAsinsDefaultFormModel = {
  sbAsins: [],
};

export function assetsAfterBrandOrTypeChange(brand: Brand | null, isVendor: boolean): SbFormAssetsModel {
  return {
    ...assetsDefaultFormModel,
    brandName: isVendor ? "" : (brand?.brandName ?? "").substring(0, BrandNameMaxLength),
  };
}
